<template>
  <nuttrema-layout-form-standard
    :edit="edit"
    :saveError="PersonSettingsTrackedMeasurements.saveError">

    <template slot="center">

      <el-form
         label-width="20em"
        :ref="formRef"
        :model="formData">

        <section>
          <h4 class="section-title">{{ $t('label.available_measurements') }}</h4>
          <div class="section-items">
            <el-collapse
               v-model="activeName"
              :accordion="true">
              <el-collapse-item
                 v-for="trackedMeasurements in _get(PersonSettingsTrackedMeasurements, 'data', [])"
                :title="trackedMeasurements.name"
                :name="trackedMeasurements.code"
                :key="trackedMeasurements.code">
                <el-form-item
                 v-for="trackingGroup in trackedMeasurements.TrackingGroups"
                :label="trackingGroup.name"
                :key="trackingGroup.id">
                  <template slot="label">
                    <el-badge
                      v-if="formData.measurementTypes[trackingGroup.id].disabled"
                      is-dot>
                      {{ trackingGroup.name }}
                    </el-badge>
                    <span v-else>{{ trackingGroup.name }}</span>
                  </template>
                  <el-row :gutter="10" style="margin-bottom: 0">
                    <el-col :span="6" style="margin-left: 1em">
                      <el-switch
                         v-model="formData.measurementTypes[trackingGroup.id].value"
                        :disabled="formData.measurementTypes[trackingGroup.id].disabled || !edit">
                      </el-switch>
                    </el-col>
                  </el-row>
                  <hr>
                </el-form-item>

                <el-form-item v-if="_get(trackedMeasurements, 'note')">
                  <p class="item_note"><strong>{{ $t('label.note') }}</strong>: <span v-html="_markdown.renderInline(_get(trackedMeasurements, 'note'))"></span></p>
                </el-form-item>


              </el-collapse-item>
            </el-collapse>
          </div>

          <p class="section-help">
            <el-badge is-dot class="item is-right"></el-badge> {{ $t('label.preselected_by_system') }}
          </p>
        </section>
      </el-form>
    </template>
    <!-- end ~ center -->

    <template slot="footer">
      <nav class="footer-row">
        <el-button
           type="primary"
           size="small"
          :loading="isSaving"
          :disabled="!isDataChanged"
          @click="submitForm">
          {{ $t('label.save') }}
        </el-button>

        <el-button
           type="text"
           size="small"
          @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </nav>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import Vue from 'vue';
import { each, pickBy, map } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-evolution-settings-tracked-measurements',
  mixins: [FormStandardBehavior],
  props: {
    PersonDetails: {
      type: Object,
      required: true,
      default: null,
    },
    PersonSettingsTrackedMeasurements: {
      type: Object,
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {},
      activeName: null,
    };
  },
  methods: {
    getFormData() {
      return {
        measurement_types: map(pickBy(this.formData.measurementTypes, item => item.value), (value, key) => key),
      };
    },
    setFormData() {
      const measurementTypes = {};
      let i = 0;
      each(this.PersonSettingsTrackedMeasurements.data, (trackedMeasurements) => {
        if (i === 0) this.activeName = trackedMeasurements.code;
        each(trackedMeasurements.TrackingGroups, (trackingGroups) => {
          Vue.set(measurementTypes, trackingGroups.id, {
            value: trackingGroups.preselected || trackingGroups.selected,
            disabled: trackingGroups.preselected,
          });
        });
        i += 1;
      });
      Vue.set(this.formData, 'measurementTypes', measurementTypes);
    },
  },
  created() {
    this.stateData = this.PersonSettingsTrackedMeasurements;
    this.formRef = 'form-evolution-settings-tracked-measurements';
    this.setFormData();
  },
};
</script>

<style lang="scss" scoped>

  .el-form {
    section {
      .section-title {
        margin-bottom: 0 !important;
      }
      .section-help {
        padding-bottom: 1em 0.5em;
      }
    }
  }

  /deep/ .el-collapse {
    border: none;
    margin-left: 1em;

    .el-collapse-item__wrap {
      background-color: transparent;
    }

    .el-collapse-item__header {
      font-size: 1rem;
      background-color: transparent;
    }

    .el-collapse-item__content {

      padding-bottom: 0.75em;

      .item_note {
        margin: 0.25em 1.5em;
        font-size: 0.9rem;
        line-height: 1.35;
      }

      .el-form-item {
        margin-bottom: 0;

        hr { margin: 0.25em 0 0.1em 0; }

        .el-form-item__label {
          .el-badge .el-badge__content {
            top: 10px;
            right: 0px;
          }
        }

        &:last-child {
          margin-bottom: 0;
          .el-form-item__content > hr { display: none; }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/settings/form-evolution-settings-tracked-measurements.vue